import React, { useState } from 'react';

import KpiComponent from '@/components/Base/KpiComponent';

import { Box, Stack, Typography } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';

// import ColumnChartTwo from '@/components/Base/ColumnChartTwo';
import { TitlePages } from '@/components/Base/TitlePage';
import CurrencyFormat from '@/utils/CurrencyFormat';
import { useConsolidationSummary } from '@/features/dashboard/api/getConsolidationSummary';
import { useContasReceberKpis } from '@/features/contas-receber/api/getContasReceberKpis';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import ColumnChartReceberVencimento from '@/components/Base/ColumnChartReceberVencimento';
import ColumnChartContasRecebidasAtraso from '@/components/Base/ColumnChartContasRecebidasAtraso';
import { useContasReceberGraficos } from '@/features/contas-receber/api/getContasReceberGraficos';
import dayjs from 'dayjs';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';

export const AccountsToReceive = () => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };

  const [selectedStartDate, setSelectedStartDate] = useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = useState(endDate);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
  };

  const { data: kpis, isError, refetch, isFetching, isFetched } = useContasReceberKpis(filters);

  const { data: contasReceberGrafico } = useContasReceberGraficos(filters);

  const onApplyFilter = (selectedYear: number) => {
    console.log('onApplyFilter selectedYear: ', selectedYear);
  };

  return (
    <>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TitlePages title={'Contas a receber'} />
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        <Stack flexDirection={'row'} gap={'8px'}>
          {kpis && isFetched && (
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#E04A4C #f1f1f1',
              }}
            >
              <KpiComponent
                title={'Total a receber'}
                value={`R$ ${CurrencyFormat.formatNumber(Number(kpis.total_receive))}`} 
                tooltipText={'Valor total de todos boletos recebíveis no mês atual.'}
                style={{ minWidth: '150px' }}
              />

              <KpiComponent
                title={'Total recebido'}
                value={`R$ ${CurrencyFormat.formatNumber(Number(kpis.total_received))}`}
                tooltipText={'Valor total de boletos liquidados no mês atual.'}
                style={{ minWidth: '150px' }}
              />
              
              <KpiComponent 
                title={'Inadimplência'} 
                value={`${kpis.inadimplance}%`} /*  value={"3%"}*/
                tooltipText={
                  <>
                    <p>
                      Relaciona&nbsp;
                      <strong>Total a receber no mês</strong>
                      &nbsp;e&nbsp;
                      <strong>Total de boletos atrasados até a data atual no mês corrente</strong>.
                    </p>
                  </>
                }
                style={{ minWidth: '150px' }}
              />
              
              <KpiComponent 
                title={'Média de dias por atraso'} 
                value={`${kpis.medium_delay}`} 
                tooltipText={'Quantos dias, em média, os boletos ficaram em atraso antes de serem pagos no mês atual.'} 
                style={{ minWidth: '170px' }}
              />

              <KpiComponent 
                title={'Contas a vencer'} 
                value={`${kpis.total_expire_payments}`} 
                tooltipText={'Todos os boletos em aberto que ainda não venceram no mês atual.'} 
                style={{ minWidth: '150px' }}
              />

              <KpiComponent 
                title={'Contas Vencidas'} 
                value={`${kpis.total_expired_payments}`}
                tooltipText={'Todos os boletos que venceram e ainda não foram pagos no mês atual.'}
                style={{ minWidth: '150px' }}
              />
            </Stack>
          )}
        </Stack>
        {isFetching && !kpis && <LoadingSummary />}

        <Box marginTop={'10px'} marginBottom={'25px'}>
          <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            showPeriodFilter={false}
          />
        </Box>

        <Box mt={'30px'}>
          <ColumnChartReceberVencimento rawData={contasReceberGrafico?.payments_per_expiration || []} />
        </Box>
        <Box mt={'30px'}>
          <ColumnChartContasRecebidasAtraso rawData={contasReceberGrafico?.payments_late_paid || []} />
        </Box>
        
      </Box>
    </>
  );
};
